module.exports = __webpack_public_path__ + "static/media/banner1_bg.62384aa2.png";